import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { FixedInfoBannerVariant } from '@kanda-libs/ks-design-library';
import { Job } from '@kanda-libs/ks-frontend-services';

import { capitaliseWords } from 'common/helpers';
import jobSelectors from 'store/selectors/job';

import { VARIANTS } from './constants';

export type BannerHook = {
  job: Job | undefined;
  visible: boolean;
  variant: FixedInfoBannerVariant;
  lenderCopy?: string;
};

export default function useBanner(): BannerHook {
  const job = useSelector(jobSelectors.getEntity);
  const hasFetched = useSelector(jobSelectors.getHasFetched);
  const isLoading = !hasFetched;

  const visible = useMemo(() => {
    if (!job || isLoading) return false;
    return job?.finance_status !== 'not_applied';
  }, [job, isLoading]);

  const provider = useMemo(() => {
    if (!job || isLoading) return undefined;
    return job?.customer_options?.finance_option?.provider;
  }, [job, isLoading]);

  return {
    job,
    visible,
    variant: provider ? VARIANTS[provider] : 'white',
    lenderCopy: provider
      ? `Current loan provider: ${capitaliseWords(provider)}`
      : undefined,
  };
}
